<template>
  <div>
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2 class="pl-2">
          {{
            editRoute
              ? $t("labels.edit_vessel_type")
              : $t("labels.add_vessel_type")
          }}
        </h2>
      </div>
    </div>
    <div class="addedit-lead center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-lead-card">
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full md:w-1/2 pl-0 mb-4">
              <label>{{ $t("labels.name") }}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="vessel_name"
                maxlength="100"
                v-model="name"
                icon-no-border
                :placeholder="$t('labels.name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{
                errors.first("vessel_name")
              }}</span>
            </div>
            <div class="vx-col sm: w-full md:w-1/2 pr-0 mb-4">
              <label>{{ $t("labels.parent_vessel_type") }}</label>
              <v-select
                v-model="parent_id"
                :options="parentVesselTypes"
                :reduce="(parentVesselTypes) => parentVesselTypes.id"
                label="name"
                class="mt-1"
              />
            </div>
          </div>
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full md:w-1/1 px-0 mb-4">
              <label>{{ $t("labels.ship_image") }}</label>
              <file-picker
                ref="filePicker"
                :acceptFormat="['.jpg', '.jpeg', '.png']"
                :isMultiple="false"
              ></file-picker>
            </div>
          </div>
          <div class="mt-2 btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-vessel-type"
              button="submit"
              >{{
                editRoute
                  ? $t("labels.update_vessel_type")
                  : $t("labels.add_vessel_type")
              }}</vs-button
            >
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
import FilePicker from "@/components/file-picker.vue";
export default {
  components: {
    FilePicker,
  },
  data() {
    return {
      name: null,
      parent_id: null,
      parentVesselTypes: [
        {
          name: this.$t("labels.no_parent"),
          id: null,
        },
      ],
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.setValidationMessage();
    this.getParentVesselTypes();
    if (this.editRoute) {
      this.getVesselType();
    }
  },
  methods: {
    async getParentVesselTypes() {
      let input = {
        only_parents: true,
      };
      let response = await this.getHTTPPostResponse("vesselType/list", input);
      if (response) {
        let vesselTypes = response.data.vesselTypes;
        let _this = this;
        let filteredTypes = [];
        for (var i = 0; i < vesselTypes.length; i++) {
          if (vesselTypes[i].id != _this.editRoute) {
            let obj = { id: vesselTypes[i].id, name: vesselTypes[i].name };
            filteredTypes.push(obj);
          }
        }
        this.parentVesselTypes = this.parentVesselTypes.concat(filteredTypes);
      }
    },
    checkValidation() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createUpdateVesselType();
        }
      });
    },
    async createUpdateVesselType() {
      const files = this.$refs.filePicker.selectedFiles || [];
      let input = {
        name: this.name,
        parent_id: this.parent_id,
      };

      const formData = new FormData();
      for (const key in input) {
        if (Object.hasOwnProperty.call(input, key)) {
          const element = input[key];
          formData.append(key, element);
        }
      }

      if (files.length && files[0].file) {
        formData.append(`ship_image`, files[0].file);
      } else if (files.length) {
        formData.append("ship_image_url", files[0].imageUrl);
      }
      let url = this.editRoute
        ? "/vesselType/update/" + this.editRoute
        : "/vesselType/create";
      let response = await this.getHTTPPostResponse(
        url,
        formData,
        "#create-vessel-type",
        true
      );
      if (response) {
        this.$router.push({ name: "VesselTypes" });
      }
    },
    async getVesselType() {
      let response = await this.getHTTPGetResponse(
        "/vesselType/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let vesselType = data.vesselType;
        this.name = vesselType.name;
        this.parent_id = vesselType.parent_id > 0 ? vesselType.parent_id : null;
        if (vesselType.ship_image_url)
          this.$refs.filePicker.selectedFiles = [
            { imageUrl: vesselType.ship_image_url, isImage: true },
          ];
      }
    },
    goBack() {
      history.back();
    },
  },
};
</script>
